import React, { useState } from 'react';
import { Product } from '../services/productService';
import '../styles/components/manualProductEntry.css';

interface ManualProductEntryProps {
  upc: string;
  token: string;
  onSave: (product: Product) => void;
  onCancel: () => void;
}

export const ManualProductEntry: React.FC<ManualProductEntryProps> = ({
  upc,
  token,
  onSave,
  onCancel
}) => {
  const [name, setName] = useState('');
  const [brand, setBrand] = useState('');
  const [size, setSize] = useState('');
  const [price, setPrice] = useState('');
  const [category, setCategory] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim()) {
      alert('Product name is required');
      return;
    }

    const product: Product = {
      upc,
      name: name.trim(),
      brand: brand.trim() || undefined,
      size: size.trim() || undefined,
      price: price ? parseFloat(price) : undefined,
      category: category.trim() || undefined
    };

    onSave(product);
  };

  return (
    <div className="manual-product-entry-modal">
      <div className="modal-content">
        <h2>Enter Product Details</h2>
        <p className="upc-info">UPC: {upc}</p>
        <p className="help-text">
          This product wasn't found in our database. Please enter the details manually.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Product Name *</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Organic Whole Milk"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="brand">Brand</label>
            <input
              id="brand"
              type="text"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              placeholder="e.g., Horizon"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="size">Size</label>
              <input
                id="size"
                type="text"
                value={size}
                onChange={(e) => setSize(e.target.value)}
                placeholder="e.g., 1 Gallon"
              />
            </div>

            <div className="form-group">
              <label htmlFor="price">Price</label>
              <input
                id="price"
                type="number"
                step="0.01"
                min="0"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="0.00"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="category">Category</label>
            <input
              id="category"
              type="text"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              placeholder="e.g., Dairy"
            />
          </div>

          <div className="action-buttons">
            <button type="submit" className="btn-primary">
              Save & Continue
            </button>
            <button type="button" onClick={onCancel} className="btn-secondary">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
